// extracted by mini-css-extract-plugin
export default {"widgetSelect":"UISelect_widgetSelect__kpEJw"};